// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-message {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-size: 16px;\n  line-height: 120%;\n  font-weight: 500;\n  color: crimson;\n}\n.fade-error-enter-active,\n.fade-error-leave-active {\n  transition: all 0.3s ease-in-out;\n}\n.fade-error-enter,\n.fade-error-leave-to {\n  opacity: 0;\n  visibility: hidden;\n  transform: translateX(30px);\n}\n", ""]);
// Exports
module.exports = exports;
